export default {
  elb : {
    title : '负载均衡',
    add:'创建负载均衡',
    all:'所有',
    location:'地区',
    noData:'没有数据，您可以',
    create:'创建一个实例',
    navTab : {
      'insM' : '实例管理',
      'cerM' : '证书管理',
      'ac' : '访问控制',
    },
    insList : {
      searchName:'搜索ID/名称',
      searchButtonName:'搜索',
      columnName : 'ID/名称',
      ipAddress : 'IP地址',
      zone : '可用区',
      period : '时效',
      port : '端口/健康检查/后端服务器组',
      status : '状态',
      actions : '操作',
      statusList:{
        Running:'运行中',
        Disabled:'已禁用',
        Deleting:'删除中',
        Failed:'失败',
        Creating:'创建中',
        Disabling:'禁用中',
        Editing:'编辑中',
        Enabling:'启用中',
        Unknown:'未知'
      },
      actionsList:{
        'manage':'管理',
        'renew':'续费'
      },
      serverType:{
        'virtual':'[虚拟]',
        'masterSlave':'[主备]'
      }
    },
    manage:{
      tab:{
        'detail':'实例详情',
        'listener':'监听',
        'virtual':'虚拟服务器组',
        'masterSlave':'主备服务器组',
      },
      insDetail:{
        'base':'基础信息',
        'name':'名称',
        'status':'状态',
        'rename':'重命名',
        'renamePage':{
          'sureRename':'确定要重命名',
          'newName':'新名称:',
          'inputTip':'请在这里输入一个新的名称',
          'characters':'字符',
          'cancel':'取消',
          'done':'完成',
        }
      },
      listener:{
        index:{
          listenerName:'添加监听',
          list:{
            id:'监听名称/ID',
            port:'前端协议/端口',
            healthStatus:'健康状态',
            group:'服务器组',
            AC:'访问控制',
            ACSwitch:{
              'off':'关闭',
              'on':'开启',
              'config':'配置',
            },
            status:'状态',
            statusList:{
              Running:'运行中',
              Disable:'已禁用',
              Fail:'失败',
              Deleting:'删除中',
              Creating:'创建中',
              Disabling:'禁用中',
              Starting:'启用中',
              Modifying:'编辑中',
            },
            actions:'操作',
            actionList:{
              'CL':'修改监听配置',
              'CF':'配置转发策略',
              'MC':'管理证书',
              'MED':'管理扩展域名',
              'stop':'停止监听',
              'delete':'删除监听',
              'start':'开始监听',
            },
          },
          rename:{
            title:'重命名监听名称',
            sure:'确定要重命名:',
            reName:'新名称',
            inputTip:'请在这里输入一个新的名称',
            characters:'字符',
            cancel:'取消',
            done:'完成',
            limit:'监听名称必须为2 ~ 64个字符',
          },
          accessControl:{
            title:'访问控制配置',
            switch:'访问控制开关:',
            switchDesc:'启用访问控制后，可以配置访问控制策略，允许或禁止某些特定IP访问负载均衡',
            method:'访问控制方法:',
            methodError:'请选择控制方法',
            group:'选择访问控制策略组:',
            groupError:'请选择选择访问控制策略组',
            cancel:'取消',
            done:'完成',
            Whitelist:'白名单',
            Blacklist:'黑名单',
            select:"请选择",
          },
          delete:{
            title:'删除监听',
            sure:'确定要删除此监听?',
            cancel:'取消',
            done:'删除',
            name:'名称:',
          },
          stop:{
            title:'停止监听',
            sure:'确定要停止此监听?',
            cancel:'取消',
            done:'停止',
            name:'名称:',
          },
          extendedDomain:{
            title:'管理扩展域名',
            input:'域名',
            inputError:'请正确输入域名',
            select:'选择服务器证书',
            add:'添加扩展域名',
            list:'扩展域名列表',
            cer:'证书名称(域名)',
            cerError:'请选择证书',
            status:'状态',
            actions:'操作',
            cancel:'取消',
            delete:'删除',
            deletePage:{
              title:'删除扩展域名',
              sure:'确定要删除扩展域名?',
              cancel:'取消',
              delete:'删除',
            },
            statusList:{
              Running:'运行中',
              Stopping:'停止中',
              Abnormal:'异常',
              Deleting:'删除中',
              Creating:'创建中',
              Editing:'编辑中',
            },
          },
          certificate:{
            title:'管理证书',
            select:'选择服务器证书:',
            buy:'购买证书',
            new:'新建服务器证书',
            cancel:'取消',
            confirm:'确定',
          },
          newCertificate:{
            title:'新建服务器证书',
            list:'证书列表:',
            listDesc:'您可以在 <a  href="/ssl/index/instance" data-v-7927e006=""class="el-button button-text el-button--default"><span>SSL 证书</span></a>服务申请证书，或上传第三方签发证书',
            cancel:'取消',
            done:'完成',
            type:'证书类型:',
            uploadYi:'上传${webTitle}颁发的证书',
            uploadNotYi:'上传非${webTitle}颁发的证书',
            name:'证书名称:',
            nameDesc:'长度限制为1-80个字符，只允许包含字母、数字、"-"、"/"、"."、"_"、"*"。',
            pubkey:'证书公钥:',
            pubkeyTip:"<li>\n" +
              "                        公钥证书包含证书的公钥和签名等信息。\n" +
              "                      </li>\n" +
              "                      <li>\n" +
              "                        负载均衡ELB使用NGINX格式的证书， 通常从证书提供商获取到的NGNIX格式的证书文件中以.pem为后缀\n" +
              "(有些可能以.crt或其他为后缀)\n" +
              " </li>",
            pubkeyView:'<p>\n' +
              '私钥样例\n' +
              '负载均衡SLB兼容NGINX格式证书文件，您可以直接上传NGINX格式的证书私钥通常格式如下，注意绿色字体部分为证书私钥文件标识符，不可省略'+
              '                      </p>\n' +
              '                      <p class="green">-----BEGIN CERTIFICATE-----</p>\n' +
              '                      <p>服务器公钥证书(BASE64编码)</p>\n' +
              '                      <p class="green">-----END CERTIFICATE-----</p>\n' +
              '                      <p>!!! 中间不能有空行!!</p>\n' +
              '                      <p class="green">-----BEGIN CERTIFICATE-----</p>\n' +
              '                      <p>\n' +
              '                       中级机构机构公钥证书\n' +
              '                        (BASE64 encoding)\n' +
              '                      </p>\n' +
              '                      <p class="green">-----END CERTIFICATE-----</p>',
            Nginx:'兼容NGINX格式。',
            View:'查看样例',
            prikey:'证书私钥:',
            priTip:'<li>\n' +
              '                       证书的私钥，通常从证书提供商获取到NGINX格式\n' +
              '的证书文件中以.key为后缀\n' +
              '                      </li>',
            prikeyView:' <p>\n' +
              '                        负载均衡ELB兼容NGINX格式\n' +
              '                        证书文件，可以直接上传\n' +
              '                        NGINX格式的证书。通常的格式是as\n' +
              '                        遵循。注意，绿色字体部分是\n' +
              '                        证书文件标识符，不能省略.\n' +
              '                      </p>\n' +
              '                      <p class="green">-----BEGIN CERTIFICATE-----</p>\n' +
              '                      <p>证书私钥(BASE64编码)</p>\n' +
              '                      <p class="green">-----END CERTIFICATE-----</p>',
            cerError:'请选择证书',
            nameError:'长度为1 ~ 80个字符',
            pubError:'请提供公钥',
            priError:'请提供私钥',
          },
          forwardingRule:{
            title:'配置转发规则',
            desc:' <li>\n' +
              '            * 域名规范:-泛解析域名:\n' +
              '            *.test.com， *必须为第一个字符，格式为 *.\n' +
              '            或* aaa。， *不能是最后一个。-标准域名:www.test.com;\n' +
              '          </li>\n' +
              '          <li>\n' +
              '            * URL规格:长度限制为2-80个字符\n' +
              '            字母，数字，\'-\'，\'/\'，\'。\', \'%\' ,\'?\'， \'#\'， \'&\'都可以使用; The\n' +
              '            URL不能只是/，但必须以/开头 /.\n' +
              '          </li>\n' +
              '          <li>* 请填写至少一个域名和URL</li>',
            domain:'域名',
            url:'地址',
            group:'服务器组',
            remark:'备注',
            actions:'操作',
            delete:'删除',
            addDomain:'添加域名',
            addRule:'添加规则',
            add:'添加转发规则',
            settings:'转发规则列表',
            status:'状态',
            cancel:'取消',
            edit:'编辑',
            select:'(请选择)',
            statusList:{
              Running:'运行中',
              Stopping:'停止中',
              Abnormal:'异常',
              Deleting:'删除中',
              Creating:'创建中',
              Editing:'编辑中',
            },
            error:{
              domain:'请输入域名',
              group:'请选择服务器组',
              url:'地址有误',
              remark:'备注有误',
            },
          },
          forwardingRuleEdit:{
            title:'管理访问控制',
            domain:'域名:',
            url:'URL:',
            group:'服务器组:',
            remark:'备注:',
            rule:'转发规则高级设置:',
            ruleDesc:'打开该开关，可以分别设置转发规则的调度算法、会话保持级别和健康检查相关设置;转发策略单独配置\n' +
              '\n\n',
            ruleScheduling:'调度算法 :',
            wrr:'加权轮询 (WRR)',
            rr:'轮询 (RR)',
            WebSocket:'WebSocket:',
            session:'会话保持:',
            sessionDesc:'tcp协议根据IP地址维护会话，并将相同IP地址的请求转发到同一后端云服务器进行处理',
            cookieHandling:'Cookie方式:',
            implant:'植入Cookie',
            rewrite:'重写Cookie',
            persistenceTimeout:'超时时间:',
            persistenceTimeoutDesc:'输入范围为1-3600秒',
            healthCheckSwitch:'健康检查开关:',
            sessionName:'Session名称:',
          },
          forwardingRuleDelete:{
            title:'删除策略',
            desc:'注意:删除后不可恢复。',
            tip:'确定删除策略?',
            cancel:'取消',
            delete:'删除',
          },
          addListener:{
            title:'负载均衡配置向导',
            first:{
              title:'协议和监听',
              protocol:'协议:',
              port:'监听端口:',
              portDesc:'端口输入范围1-65535',
              setting:'高级配置',
              redirection:'监听转发:',
              redirectionTip:'用于将HTTP:80监听的流量转发到HTTPS:443监听，以实现HTTP协议强制跳转HTTPS。',
              webSocket:'WebSocket:',
              Session:'会话保持:',
              SessionTip:'tcp 协议基于IP地址进行会话保持，将同一IP地址的请求转发到同一台后端云服务器处理。',
              schedulingAlgorithm:'调度算法:',
              wrr:'加权轮询 (WRR)',
              wrrTip:'加权轮询：权重值越高的后端服务器，被轮询到的次数(概率)也越高',
              rr:'轮询（RR）',
              rrTip:'按照访问顺序依次将外部请求依序分发到后端服务器。',
              requestTimeout:'连接请求超时:',
              s:'秒',
              requestTimeoutTip:'配置TCP连接超时，连接空闲时间超过该时长后，负载均衡会主动断开该连接。TCP超时时间输入范围为10—900秒，http/https超时时间输入范围为1—180秒',
              idleTimeout:'连接空闲超时:',
              idleTimeoutTip:'在超过时间内一直没有访问请求，负载均衡会暂时中断当前连接，直到一下次请求来临时重新建立新的连接。',
              listenerName:'监听名称:',
              listenerNameDesc:'2-64 字符',
              targetPort:'监听端口:',
              targetPortTip:'负载均衡对外提供服务的端口，通常HTTP协议使用80端口，HTTPS协议使用443端口',
              targetPortDesc:'请选择',
              cookieHandlingOptions:'Cookie处理方式:',
              SessionPersistenceTimeout:'会话超时时间:',
              bandwidthPeak:'带宽峰值',
              accessControl:'访问控制',
              cookieName:'Cookie名称:',
              implantCookie:'植入Cookie',
              rewriteCookie:'重写Cookie',
              certificate:'证书:',
              newCer:'新的服务器证书',
              buyCer:'购买证书',
              OFF:'关闭',
              ON:'开启',
              Unlimited:'无限',
            },
            two:{
              title:'后端服务器',
              desc:'请选择将监听请求转发至哪类后端服务器：',
              Virtual:'虚拟服务器组',
              VirtualTip:'每个负载均衡实例可以创建多个虚拟服务器组，虚拟服务组可关联到监听或转发规则，实现将不同业务转发到不同的后端服务器的功能',
              Master:'主备服务器组',
              MasterTip:'主备服务器组是一种特殊的服务器组，同一时刻只有主或备处于工作状态，当主服务器健康检查异常后，会自动切换到备服务器，当主服务器恢复正常时，再切换为主工作',
              group:'选择服务器组：',
              newVirtual:'新增虚拟服务器组',
              newMaster:'新增主备服务器组',
              select:'选择服务器组：',
              list:{
                ECSID:'云服务器ID',
                Zone:'可用区',
                Status:'状态',
                statuslist:{
                  Creating:'创建中',
                  Installing:'安装中',
                  Starting:'启动中',
                  Running:'运行中',
                  Stopped:'已停止',
                  ExpiringSoon:'快过期',
                  Expired:'已过期',
                  Invalid:'已失效',
                  Reinstalling:'重装中',
                  ShuttingDown:'关机中',
                  PoweredOff:'已关机',
                  ExpireSoon:'快过期',
                  Unknown:'未知',
                },
                Port:'端口',
                PortDesc:'输入范围1-65535',
                Weight:'权重',
                WeightDesc:" <ul>\n" +
                  "                                <li>\n" +
                  "                                  权重越大转发的请求越多，默认为100；\n" +
                  "                                </li>\n" +
                  "                                <li>\n" +
                  "                                  如开启会话保持, 可能会造成后端服务器的请求不均匀；\n" +
                  "                                </li>\n" +
                  "                                <li>\n" +
                  "                                  权重设置为0，该服务器不会再接受新请求；\n" +
                  "                                </li>\n" +
                  "                              </ul>",
                Actions:'操作',
                ActionssList:{
                  remove:'移除',
                },
                machineType:'机器类型',
                Master:'主',
                Slave:'备',
              },
            },
            third:{
              title:'健康检查',
              healthCheck:'健康检查:',
              healthCheckTip:'使用HTTP协议进行健康检查时，默认使用GET方法请求.',
              healthCheckMethod:'健康检查方法:',
              path:'健康检查地址:',
              pathTip:'用于健康检查页面文件的URI，建议检查静态页面.',
              domain:'健康检查域名(可选):',
              domainTip:'缺失情况下，域名使用各后端服务器的内网IP地址.',
              domainDesc:'只有字母、数字、“-”和“”。可以使用的.',
              normalStatusCode:'正常的状态码:',
              check:'健康检查端口:',
              checkDesc:'输入范围1-65535',
              checkTip:'后端服务器端口默认为检查端口，建议不填写，除非指定端口',
              responce:'相应超时时间:',
              inspection:'检查间隔时间:',
              health:'健康阈值:',
              unhealth:'不健康阈值:',
            },
            fourth:{
              title:'配置检查',
              protocol:'协议和监控',
              ELBProtocol:'负载均衡协议:',
              listeningPort:'监听端口:',
              schedulingAlgorithm:'调度算法:',
              sessionPersistence:'会话保持:',
              accessControl: '访问控制:',
              bandwidthPeak: '带宽峰值:',
              requestTimeout:'连接超时时间:',
              healthCheck:'健康检查',
              healthChecked:'健康检查:',
              healthCheckProtoco:'健康检查协议:',
              responceTimeout:'相应超时时间:',
              Inspection:'检查间隔时间:',
              health:'健康阈值:',
              unhealth:'不健康阈值:',
              configuratePort:'配置端口',
            },
            error:{
              protocol:'请选择协议',
              listenPort:'监听端口输入错误',
              listenPortExists:'监听端口已经存在',
              listenName:'监听名字错误',
              requestTimeout:'请求超时不匹配(1-180)',
              targetPort:'请选择目标监听',
              forwardPortNeed:'启用监听转发的监听端口需要为80',
              idleTimeout:'空闲超时不匹配(1-60)',
              cookieHandling:'请选择Cookie处理方式',
              persistenceTimeout:'持久超时输入错误',
              cookieName:'CookieName有误',
              certificate:'请选择证书',
              serverGroup:'请选择服务器组',
              normalStatus:'请选择正常状态码',
              healthCheckPath:'请输入健康检查路径',
              responceTimeout:'响应时间错误',
              inspectionInterval:'检查间隔有误',
              healthThreshold:'健康阈值有误',
              unhealth:'不健康阈值有误',
            },
            Previous:'上一步',
            Next:'下一步',
            Done:'完成',
            Cancel:'取消',
            Edit:'编辑',
          },
          virtualGroup:{
            addTitle:'创建虚拟服务器组',
            list:{
              name:'名称/ID',
              listen:'关联的监听',
              Forward:'关联监听转发策略',
              status:'状态',
              actions:'操作',
              edit:'编辑',
              delete:'删除',
              domain:'域名',
              url:'地址',
              statusList:{
                Running:'运行中',
                Disable:'禁用',
                Fail:'失败',
                Deleting:'删除中',
                Creating:'创建中',
                Modify:'编辑中',
              },
            },
            add:{
              title:'创建虚拟服务器组',
              desc:'当前负载均衡网络类型为经典网络，实例类型为私网，虚拟服务器组内可以添加经典网络或者专有网络类型的云服务器',
              name:'虚拟服务器名称',
              add:'添加',
              cancel:'取消',
              save:'确定',
              remove:'移除',
              actions:'操作',
            },
            serverList:{
              title:'我的服务器',
              one:' 选择服务器',
              two:'端口配置',
              cancel:'取消',
              next:'下一步',
              previous:'上一步',
              done:'完成',
              statusList:[
                { text: '运行中', value: 4 },
                { text: '停止', value: 6 },
                { text: '已失效', value: 7 },
              ],
            },
            editName:{
              title:'重命名',
              sure:'确定重命名',
              name:'新名称',
              tip:'请输入新的名称',
              desc:'6-64 字符',
              cancel:'取消',
              done:'完成',
            },
            edit:{
              title:'编辑虚拟服务器组',
            },
            delete:{
              title:'删除虚拟服务器组',
              tip:'确定要删除虚拟服务器组?',
              name:'名称:',
              cancel:'取消',
              delete:'删除',
            },
            error:{
              port:'请填写端口',
              weight:'请填写权重',
            },
          },
          mSGroup:{
            addTitle:'创建主备服务器组',
            list:{
              name:'名称ID',
              listen:'关联监听',
              Forward:'关联监听转发策略',
              status:'状态',
              actions:'操作',
              view:'详情',
              delete:'删除',
              domain:'域名',
              url:'地址',
              statusList:{
                Running:'运行中',
                Disable:'禁用',
                Fail:'失败',
                Deleting:'删除中',
                Creating:'创建中',
                Modify:'编辑中',
              },
            },
            add:{
              title:'创建主备服务器组',
              desc:'当前负载均衡网络类型为经典网络，实例类型为私网。 您可以将经典网络或VPC类型的云服务器添加到主从服务器组。',
              name:'主备服务器组名称',
              add:'添加',
              save:'确定',
            },
            detail:{
              title:'主备服务器组详情',
              name:'主备服务器组名称',
              cancel:'取消',
            },
            delete:{
              title:'删除主备服务器组',
              tip:'确定删除主备服务器组',
              name:'名称:',
              cancel:'取消',
              delete:'删除',
            },
            error:{
              port:'请输入端口',
              portSame:'端口号不可相同',
              select:'只能选择2个',
            },
          },
        }
      }
    },
    cerManage:{
      search:'搜索',
      searchTip:'搜索证书',
      add:'创建证书',
      list:{
        name:'证书名称/ID',
        domain:'证书域名',
        time:'创建时间',
        expired:'过期时间',
        actions:'操作',
        listen:'关联监听 <br/>\n' +
          '扩展域名',
        delete:'删除',
      },
      reName:{
        title:'重命名证书',
        sure:'确定重命名',
        name:'新名称:',
        nameTip:'请输入新的名称',
        nameDesc:'6-64 字符',
        cancel:'取消',
        done:'完成',
      },
      delete:{
        title:'删除证书',
        sure:'确认删除证书?',
        id:'证书Id:',
        domain:'证书域名 :',
        cancel:'取消',
        delete:'删除',
      },
    },
    policy:{
      search:'搜索',
      searchTip:'搜索名称',
      addTip:'创建访问控制策略组',
      add:{
        title:'创建访问控制策略组',
        desc:' <li>1. 每个条目一行，以回车分隔。</li>\n' +
          '            <li>\n' +
          '              2. 每个条目的地址/地址段和备注以|分隔，如“192.168.1.0/24 | 备注”。\n' +
          '            </li>',
        name:'名称:',
        nameDesc:'长度为1 ~ 80，由字母、数字、“-”、“/”、“。”、“_”和“*”组成。',
        version:'IP版本:',
        add:'批量添加',
        addTip:'1. 每个条目一行，以回车分隔。1111\n' +
          '2. 每个条目的地址/地址段和备注以|分隔，如“192.168.1.0/24 | 备注”。',
        cancel:'取消',
        done:'完成',
      },
      list:{
        name:'策略组名称/策略组ID',
        version:'IP版本',
        listen:'关联的监听',
        actions:'操作',
        delete:'删除',
        manage:'管理',
      },
      reName:{
        title:'重命名策略组',
        sure:'确定重命名',
        name:'新名称:',
        nameTip:'请输入新的名称',
        nameDesc:'6-64 字符',
        cancel:'取消',
        done:'完成',
      },
      delete:{
        title:'删除策略组',
        sure:'确定删除策略组',
        sureTip:'注意:删除后不可恢复。',
        cancel:'取消',
        delete:'删除',
      },
      manage:{
        title:'管理访问控制策略组',
        add:'批量添加',
        addTip:'1. 每个条目一行，以回车分隔。\n' +
          '2. 每个条目的地址/地址段和备注以|分隔，如“192.168.1.0/24|备注”',
        delete:'批量删除',
        cancel:'关闭',
        save:'保存',
        del:'删除',
        list:{
          id:'ID',
          address:'条目',
          remark:'备注',
          actions:'操作',
        },
        deletePage:{
          title:'删除条目',
          sure:'确定要删除这个条目 ?',
          address:'地址:',
          remark:'备注:',
          delete:'删除',
          cancel:'取消',
        },
        massDel:{
          title:'批量删除条目',
          sure:'确认删除多个条目?',
          cancel:'取消',
          delete:'删除',
        },
      },
      error:{
        line:'请确保每行均为网段(|备注)',
      }
    },
    renew:{
      title:'续费',
      desc:'实例当前配置',
      summary:'配置',
      cpu:'核',
      cores:'',
      core:'',
      bandwidth:'M',
      ram:'G',
      address:'IP地址',
      duration:'续费时长:',
      durationList:[
        {
          label: "1 月",
          value: 1,
        },
        {
          label: "2 月",
          value: 2,
        },
        {
          label: "3 月",
          value: 3,
        },
        {
          label: "6 月",
          value: 6,
        },
        {
          label: "1 年",
          value: 12,
        },
        {
          label: "2 年",
          value: 24,
        },
      ],
      price:'价格: ',
      cancel:'取消',
      pay:'支付',
      copySuccess:'复制成功',
      copyFail:'复制失败',
      copy:'复制',
    },
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh-CN/elb.js